import ViewCustomer from "../../../../components/@users/customers/ViewCustomer";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CustomerViewPage() {

    return (
        <ViewCustomer 
            routeType={routeTypes.admin}
        />
    )
}       